/**
 * @generated SignedSource<<9a638fee7333003c80b3a9aaad55465b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SimpleMenuMainNavigation_platform",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publishedLocales",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "primaryColor",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "LocaleSwitch_platform"
    }
  ],
  "type": "Platform",
  "abstractKey": null
};

node.hash = "fc459139744c6f6bbddb953f400d5f4c";

module.exports = node;
